import React, { useMemo } from 'react';
import { useStatistics } from './StatiscticsContext';
import {
  createColumnHelper,
  useReactTable,
  flexRender,
  getCoreRowModel,
} from '@tanstack/react-table';
import { autoComma } from '@/utils/parser';

const columnHelper = createColumnHelper<SalesProduct>();

const ProductSalesSection = () => {
  const { salesProductList } = useStatistics();

  const columns = useMemo(
    () => [
      columnHelper.display({
        id: 'rank',
        header: '순위',
        cell: (info) => info.row.index + 1,
      }),
      columnHelper.accessor('ProductName', {
        header: '상품명',
        cell: (info) => <span className="block truncate">{info.getValue()}</span>,
      }),
      columnHelper.accessor('ProductOptionName', {
        header: '옵션명',
        cell: (info) => <span className="block truncate">{info.getValue()}</span>,
      }),
      columnHelper.accessor('SalesAmount', {
        header: '금액',
        cell: (info) => <span>{autoComma(info.getValue())}원</span>,
      }),
      columnHelper.accessor('SalesCount', {
        header: '판매건수',
        cell: (info) => <span>{autoComma(info.getValue())}개</span>,
      }),
      columnHelper.accessor('MarketName', {
        header: '마켓명',
        cell: (info) => (
          <div className="flex items-center gap-2">
            <img
              src={info.row.original.MarketIconUrl}
              alt="마켓 아이콘"
              className="h-5 w-5 rounded-full"
            />
            <span>{info.getValue()}</span>
          </div>
        ),
      }),
    ],
    [],
  );

  const table = useReactTable({
    data: salesProductList,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className=" flex h-full max-h-[540px] w-full flex-col gap-[16px] overflow-auto rounded-[16px] bg-white p-6">
      <div className="text-gr-900 Body1S16">많이 팔린 상품</div>
      <div className="scrollbar w-full overflow-x-auto">
        <table className="w-full table-auto rounded-t-[8px]">
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id} className="border-b">
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="whitespace-nowrap bg-gr-50 px-[10px] py-2 text-left align-middle text-gr-800 Caption1M12"
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className="border-b hover:bg-gr-50">
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className={
                      cell.column.id === 'ProductName' || cell.column.id === 'ProductOptionName'
                        ? 'truncate px-[10px] py-2 text-left align-middle text-gr-800 Body5M14'
                        : 'whitespace-nowrap px-[10px] py-2 text-left align-middle text-gr-800 Body5M14'
                    }
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductSalesSection;
